module.exports = __webpack_public_path__ + "img/hero-banners-dropdown-search-infiniti-24.1ecdfe70.jpg";